export default __webpack_public_path__ + "static/webhot-panorama-bgc-132b8d56fce5e279eaff3dae3ba0af23.png";